package com.merkost.handpass.admin.container

import com.merkost.handpass.admin.api.AdminRepositoryApi
import com.merkost.handpass.admin.contract.AsyncSection
import com.merkost.handpass.admin.contract.FeatureFlagsAction
import com.merkost.handpass.admin.contract.FeatureFlagsIntent
import com.merkost.handpass.admin.contract.FeatureFlagsState
import com.merkost.handpass.admin.platform.WindowFocusTrigger
import com.merkost.handpass.admin.util.toAdminMessage
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import pro.respawn.flowmvi.api.Container
import pro.respawn.flowmvi.dsl.lazyStore
import pro.respawn.flowmvi.plugins.recover
import pro.respawn.flowmvi.plugins.reduce

class FeatureFlagsContainer(
    private val repo: AdminRepositoryApi,
    private val focusTrigger: WindowFocusTrigger,
) : Container<FeatureFlagsState, FeatureFlagsIntent, FeatureFlagsAction> {

    private val scope = MainScope()

    override val store by lazyStore(FeatureFlagsState(), scope) {
        configure { name = "FeatureFlagsStore" }
        recover { e ->
            updateState { copy(flags = AsyncSection.Failed(e.toAdminMessage())) }
            null
        }
        reduce { intent ->
            when (intent) {
                is FeatureFlagsIntent.ReactToFocusTick, FeatureFlagsIntent.Refresh -> {
                    val flags = repo.getFeatureFlags()
                    updateState {
                        copy(
                            flags = if (flags != null) AsyncSection.Loaded(flags)
                            else AsyncSection.Failed("Could not reach the API"),
                        )
                    }
                }
                is FeatureFlagsIntent.Toggle -> {
                    updateState { copy(pendingKeys = pendingKeys + intent.key) }
                    repo.setFeatureFlag(intent.key, intent.enabled)
                    val flags = repo.getFeatureFlags()
                    updateState {
                        copy(
                            pendingKeys = pendingKeys - intent.key,
                            flags = if (flags != null) AsyncSection.Loaded(flags) else this.flags,
                        )
                    }
                }
            }
        }
    }

    init {
        scope.launch {
            focusTrigger.ticks.collect { tick -> store.intent(FeatureFlagsIntent.ReactToFocusTick(tick)) }
        }
    }
}
